import {FaqCategory} from './FaqCategory';

export class Event {
  id: number;
  type: string;
  datetime: string;
  title: string;
  description: string;
  linktitle: string;
  link: string;
  categories: FaqCategory[] = [];

  beginDate: string;
  endDate: string;
}
